import React, { FC, useState } from "react";
import { RouteComponentProps } from "react-router-dom";

import { NewInsuredContainer } from "../new-insured/newInsuredStepper-style";
import BreadcrumbText from "../../../../components/components-text/breadcrumb-text";
import InputBox from "../../../../components/input-box/input-box";
import RequiredDocumentsStep from "../new-insured/required-documents/required-documents-step";
import MainButton from "../../../../components/main-button";
import { Button } from "../../../../components/buttons";
import LeftInfoModal from "../../../../components/left-info-modal";
import { images } from "../../../../assets";
import { TakerDataContainer } from "../../../hirings/new-hiring/health/health-taker/taker-data-style";

import useForm from "../hooks/useForm";
import { SupplementsContext } from "../../../../context/supplements/SupplementsContext";
import SupplementsServices from "../../../../services/SupplementsServices";
import CancellationServices from "../../../../services/CancellationService";
import { getMediatorCode } from "../../../../utils/mediatorCode";
import { getPolicyNumber, redirect } from "../utils";
import { MatchParams } from "../basic-data/basic-data.types";
import { validateUnsubscriptionData } from "./utils";

const PolicyHolderUnsubscription: FC<RouteComponentProps<MatchParams>>  = ({ history }) => {
  const supplementsContext = React.useContext(SupplementsContext);
  const [modal, setModal] = useState<{msg: string, status: boolean, type: string}>({ msg: "", status: false, type: "" });
  const [confirmationModal, setConfirmationModal] = useState<boolean>(false);
  const { values, errors, handleChange, setErrors } = useForm(
    {
      documents: { uploadDocuments: [] },
      nameSelected: '0',
      isUnsubscribe: true
    },
    () => validateUnsubscriptionData(values, supplementsContext.supplementDocs),
    true
  );

  const handleDownload = async () => {
    try {
      await CancellationServices.get();
    } catch (err) {
      setModal({ msg: 'Ha habido un error al descargar el documento de baja', status: true, type: "error" });
    }
  }

  const handleSubmit = async () => {
    const response = await SupplementsServices.sendBasicDataModificationsEmail(
      values
    );

    if (response.data.status) {
      setModal({
        msg: "Los datos han sido enviado correctamente",
        status: true,
        type: "success",
      });
    } else {
      setModal({ msg: response.data.msg, status: true, type: "error" });
    }
  };

  const validateForm = () => {
    const { errors, hasValidation } = validateUnsubscriptionData(values, supplementsContext.supplementDocs);
    if (hasValidation) {
      setConfirmationModal(true);
    } else {
      setErrors(errors);
    }
  };

  return (
    <NewInsuredContainer>
      <div className="subTitle">
        <BreadcrumbText>NUEVO SUPLEMENTO - SOLICITUD DE BAJA</BreadcrumbText>
      </div>
      <div className="personal-data-row form-width container-background">
        <div className="personal-data-item col-50">
          <div className="inputBox">
            <InputBox
              placeholder="Mediador"
              required={true}
              disabled={true}
              value={getMediatorCode()}
              onChange={() => {}}
              type={"letters"}
            />
          </div>
        </div>
        <div className="personal-data-item col-50">
          <div className="inputBox">
            <InputBox
              placeholder="Datos de Póliza a modificar"
              required={true}
              disabled={true}
              value={getPolicyNumber()}
              onChange={() => {}}
              type={"letters"}
            />
          </div>
        </div>
      </div>
      <div className="personal-data-row form-width container-background">
        <Button
          text="Descargar solicitud de baja"
          onClick={handleDownload}
        />
      </div>
      <div className="personal-data-row form-width container-background no-padding">
        <div className="personal-data-item col-100">
          <RequiredDocumentsStep
            values={values}
            errors={errors}
            handleChange={handleChange}
            hideTitle
            hideInsurance
            title="JUSTIFICATIVOS DE LA SOLICITUD DE BAJA"
            setErrors={setErrors}
          />
        </div>
      </div>
      <TakerDataContainer>
        <div className="colSin-100 topMargin20 bottomMargin20">
          <div className="personal-data-buttons">
            <div className="personal-data-buttons__item">
              <MainButton
                withTab={true}
                icon={true}
                type={"white"}
                iconImg={images.IconArrowLeftBlue}
                disabled={false}
                text="Atrás"
                onClick={() =>
                  history.push(`/suplementos/${getPolicyNumber()}`)
                }
              />
            </div>
            <div className="personal-data-buttons__item">
              <MainButton withTab={true} text="Enviar" onClick={validateForm} />
            </div>
          </div>
        </div>
      </TakerDataContainer>
      <LeftInfoModal
        img={ modal.type === "error" ? images.WarningError : images.IconCheckGreen2 }
        mainTitle={modal.type === "error" ? "Error" : "Aviso"}
        mainText={modal.msg}
        noSecondaryButton={true}
        buttonText="Continuar"
        active={modal.status}
        onClickAccept={() => redirect(setModal, history)}
        close={() => redirect(setModal, history)}
        className={modal.type === "error" ? "error" : "info"}
      />
      <LeftInfoModal
        img={images.IconCheckGreen2}
        mainTitle={"Aviso"}
        mainText={"Se va a enviar un suplemento de Baja de Asegurado/Póliza"}
        secondaryText={"¿Desea Continuar?"}
        noSecondaryButton={false}
        buttonText={"Si"}
        closeButtonText={"NO"}
        active={confirmationModal}
        onClickAccept={handleSubmit}
        close={() => setConfirmationModal(false)}
        className={"info"}
      />
    </NewInsuredContainer>
  );
};

export default PolicyHolderUnsubscription;